<template>
  <div class="report_manager">
    <v-overlay :value="overlay" :z-index="999999999999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <!-- TOOLBAR -->
      <v-toolbar dense color="primary" dark align="center">
        <v-row>
          <v-col cols="5" align="left">
            <v-toolbar-title>Gestione Report Aziende</v-toolbar-title>
          </v-col>
          <v-col cols="2" align="center" />
          <v-col cols="4" align="right">
            <v-btn small light @click="getReportAziende">
              <v-icon color="primary">mdi-autorenew</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1" align="right">
            <v-btn small light @click="$router.push('/home')">
              <v-icon color="error">mdi-keyboard-backspace</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
      <!-- BODY -->
      <v-container>
        <div class="tree_container">
          <v-text-field
            v-model="filter"
            label="Filtra Clienti"
            prepend-icon="mdi-account-search"
          />
          <v-treeview
            :items="filterCustomers(filter)"
            item-key="id"
            open-on-click
            item-children="report"
          >
            <template v-slot:prepend="{ item }">
              <v-icon>
                {{ item.ragione_sociale == undefined ? "mdi-file" : "mdi-account-tie" }}
              </v-icon>
            </template>
            <template v-slot:label="{ item }">
              <span class="tree_label" :data-customer="item.ragione_sociale != undefined">
                {{
                  item.ragione_sociale == undefined
                    ? item?.cod_report
                    : item.ragione_sociale
                }}
              </span>
            </template>
            <template v-slot:append="{ item }">
              <div v-if="item.ragione_sociale == undefined">
                <!-- MODIFICA REPORT -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" @click="showEditDialog(item)">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Modifica Report</span>
                </v-tooltip>
                <!-- SCARICA REPORT -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="downloadReportModel(item)"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <span>Scarica Report</span>
                </v-tooltip>
                <!-- ELIMINA REPORT -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="showDeleteDialog(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Elimina Report</span>
                </v-tooltip>
              </div>
              <div v-else>
                <!-- AGGIUNGI REPORT -->
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click.stop="showEditDialog(null, item)"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi Report</span>
                </v-tooltip>
              </div>
            </template>
          </v-treeview>
        </div>
      </v-container>
    </v-card>
    <!-- DIALOG CONFERMA ELIMINAZIONE -->
    <v-dialog v-model="alert.delete.show" width="500" persistent>
      <v-card>
        <v-container>
          <v-card-title
            >Eliminare {{ alert.delete.report_name }}" per
            {{ alert.delete.customer_name }}?</v-card-title
          >
          <v-card-text class="text-left"
            >Le funzioni di stampa ancora collegate a questo documento genereranno un
            errore.</v-card-text
          >
        </v-container>
        <v-card-actions>
          <v-btn text @click="alert.delete.show = false">Annulla</v-btn>
          <v-spacer />
          <v-btn text color="error" @click="deleteReport">Elimina</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG MODIFICA / CREA -->
    <v-dialog v-model="alert.edit.show" persistent width="900">
      <v-card v-if="alert.edit.show == true">
        <v-toolbar dense dark color="primary">
          <v-row>
            <v-col cols="5" align="left">
              <v-toolbar-title>{{ alert.edit.text }}</v-toolbar-title>
            </v-col>
            <v-col cols="2">
              <v-btn small light @click="setReportAzienda(alert.edit.report)">
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
              <v-btn
                class="ml-5"
                small
                light
                @click="showQueryControlloDialog(alert.edit.report.query_controllo)"
              >
                <v-icon color="primary">mdi-database-eye</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="4" align="right">
              <v-menu
                v-model="alert.edit.menu_test.show"
                bottom
                :nudge-width="400"
                offset-y
                :nudge-left="400"
                :nudge-bottom="5"
                :close-on-content-click="false"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small light v-bind="attrs" v-on="on" @click="getParams">
                    <v-icon color="indigo">mdi-test-tube</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-container>
                    <v-data-table
                      :items="alert.edit.menu_test.parameters"
                      :headers="ui.param_headers"
                      hide-default-footer
                      disable-pagination
                    >
                      <template v-slot:top>
                        <v-toolbar color="primary" dark dense rounded>
                          <v-row justify="center">
                            <v-col cols="12" align="center">
                              <v-btn
                                small
                                light
                                @click="addParam(alert.edit.menu_test.parameters)"
                              >
                                <v-icon color="success">mdi-plus</v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-toolbar>
                      </template>
                      <!-- Nome parametro -->
                      <template v-slot:[`item.parametro`]="{ item }">
                        <v-text-field
                          v-model="item.parametro"
                          class="pa-0"
                          label="@Parametro"
                        />
                      </template>
                      <!-- Valore parametro -->
                      <template v-slot:[`item.valore`]="{ item }">
                        <v-text-field v-model="item.valore" class="pa-0" label="Valore" />
                      </template>
                      <!-- Elimina parametro -->
                      <template v-slot:[`item._delete`]="{ item }">
                        <v-btn
                          icon
                          @click="removeParam(item, alert.edit.menu_test.parameters)"
                        >
                          <v-icon color="error">mdi-delete</v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
                    <!-- v-row justify="center">
                                            <v-col cols="12" align="center">
                                                <v-text-field v-model="alert.edit.menu_test.parameters" class="pa-0" type="number" label="ID Documento" style="width:230px" />
                                            </v-col>                                        
                                        </v-row -->
                  </v-container>
                  <v-card-actions>
                    <v-btn
                      text
                      color="primary"
                      @click="
                        generateDictionary(
                          alert.edit.report,
                          alert.edit.menu_test.parameters
                        )
                      "
                      >Generazione dictionary</v-btn
                    >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="
                        testReport(alert.edit.report, alert.edit.menu_test.parameters)
                      "
                      >Esegui Test</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="1" align="right">
              <v-btn small light @click="alert.edit.show = false">
                <v-icon color="error">mdi-keyboard-backspace</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-toolbar>
        <v-container>
          <v-row justify="center">
            <v-col cols="6">
              <v-text-field
                v-model="alert.edit.report.cod_report"
                label="Nome Report"
                prepend-icon="mdi-file"
              />
            </v-col>
            <v-col cols="6">
              <v-autocomplete
                v-model="alert.edit.report.id_famiglia"
                :items="items_famiglie_report"
                item-text="des"
                item-value="id_tabella"
                label="Famiglia Report"
              >
                <template #label>
                  <span class="">Famiglia<strong>*</strong></span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="getTabelle"
                      tipo="FAMIGLIA_REPORT"
                      nome="Famiglia"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }, { val_txt: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-divider />
          <v-row
            v-if="alert.edit.report.query[0]"
            class="mt-4"
            justify="center"
            align="center"
          >
            <v-col cols="6">
              <v-select
                prepend-icon="mdi-table-cog"
                :items="lista_query"
                item-text="titolo"
                return-object
                v-model="query_sel"
                label="Seleziona una query"
                @change="changeQuery(query_sel)"
              />
            </v-col>
            <v-col cols="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="apriDialogQueryToTable" v-bind="attrs" v-on="on" small>
                    <v-icon color="primary">mdi-database-plus</v-icon>
                  </v-btn>
                </template>
                <span>Aggiungi una query</span>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-row
            align="center"
            class="mb-2"
            justify="center"
            v-for="(query, i) in alert.edit.report.query"
            :key="i"
          >
            <v-col cols="7">
              <v-text-field
                hide-details
                prepend-icon="mdi-table-cog"
                :label="`Query per ${query.nome_tabella ? query.nome_tabella : 'report'}`"
                readonly
                @click="showQueryDialog(query, i)"
                v-bind:value="query.query"
              />
            </v-col>
          </v-row>
        </v-container>
        <v-divider v-if="alert.edit.report.query[0]" />
        <v-card-actions>
          <v-btn
            text
            color="primary"
            :disabled="alert.edit.report.modello == null"
            @click="downloadReportModel(alert.edit.report)"
          >
            <v-icon class="mr-5" color="primary" v-if="alert.edit.report.modello != null">
              mdi-download
            </v-icon>
            {{
              alert.edit.report.modello == null
                ? "Nessun modello allegato"
                : "Scarica modello offline"
            }}
          </v-btn>
          <v-spacer />
          <v-btn text color="primary" @click="uploadReportModel">
            <v-icon class="mr-5">mdi-upload</v-icon>
            Carica modello
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG EDITOR QUERY -->
    <v-dialog v-model="alert.query.show" width="90%">
      <v-card v-if="alert.query.show == true">
        <v-toolbar dense dark color="primary">
          <v-spacer> </v-spacer>
          <v-btn @click="openDialogParametri" class="mr-2" light small>
            <v-icon color="primary">mdi-play</v-icon>
          </v-btn>

          <v-btn :disabled="query_analizzata" small light @click="saveQuery">
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
          <v-spacer> </v-spacer>
          <v-btn small light @click="alert.query.show = false">
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <QueryEditor
            v-model="alert.query.query"
            :template="editor"
            query_field="query"
            @analyze="analizzaQuery"
          />
        </v-container>
      </v-card>
    </v-dialog>
    <!-- DIALOG EDITOR QUERY CONTROLLO -->
    <v-dialog v-model="alert.query_controllo.show" width="90%">
      <v-card v-if="alert.query_controllo.show == true">
        <v-toolbar dense dark color="primary">
          <v-spacer> </v-spacer>
          <v-btn @click="openDialogParametriControllo" class="mr-2" light small>
            <v-icon color="primary">mdi-play</v-icon>
          </v-btn>

          <v-btn
            :disabled="query_controllo_analizzata"
            small
            light
            @click="saveQueryControllo"
          >
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
          <v-spacer> </v-spacer>
          <v-btn small light @click="alert.query_controllo.show = false">
            <v-icon color="error">mdi-keyboard-backspace</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <QueryEditor
            v-model="alert.query_controllo.query"
            :template="editor"
            query_field="query"
            @analyze="analizzaQueryControllo"
          />
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog Query to Table -->
    <v-dialog persistent v-model="dialog_query_table">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>Lista Query</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closeDialogQueryToTable" v-bind="attrs" v-on="on" small>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-container class="ma-2">
          <TabellaCustomAdapter :from_label="from_label" />
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog_parametri" width="50%">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>Parametri</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="playQuery('query')" v-bind="attrs" v-on="on" small>
                <v-icon color="primary">mdi-play</v-icon>
              </v-btn>
            </template>
            <span>Play</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaDictionary('query')"
                v-bind="attrs"
                v-on="on"
                small
                class="ml-5"
              >
                <v-icon color="primary">mdi-download</v-icon>
              </v-btn>
            </template>
            <span>Scarica dictionary</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_parametri = false;
                  parametri_sel = [];
                "
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container>
          <v-data-table :headers="headers_parametri" :items="parametri_sel">
            <template v-slot:[`item.value`]="{ item }">
              <v-text-field v-model="item.value" required label="Inserisci un valore" />
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="dialog_parametri_controllo" width="50%">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>Parametri</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="playQuery('query_controllo')" v-bind="attrs" v-on="on" small>
                <v-icon color="primary">mdi-play</v-icon>
              </v-btn>
            </template>
            <span>Play</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_parametri_controllo = false;
                  parametri_sel = [];
                "
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container>
          <v-data-table :headers="headers_parametri" :items="parametri_sel">
            <template v-slot:[`item.value`]="{ item }">
              <v-text-field v-model="item.value" required label="Inserisci un valore" />
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog_preview" width="80%">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>Preview Query</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="dialog_preview = false" v-bind="attrs" v-on="on" small>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-container>
          <v-data-table :headers="preview.colonne" :items="preview.result">
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="dialog_query_table">
      <v-card>
        <v-toolbar dense color="indigo" class="white--text">
          <v-toolbar-title>Lista Query</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="closeDialogQueryToTable" v-bind="attrs" v-on="on" small>
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-container class="ma-2">
          <TabellaCustomAdapter :from_label="from_label" />
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import QueryEditor from "@/components/GRAPH/Dashboard/Editor/QueryParser/QueryEditor.vue";
import TabellaCustomAdapter from "@/components/TABELLA_CUSTOM/TabellaCustomAdapter.vue";

export default {
  name: "ReportManager",
  components: {
    Modules: () => import("../../components/TOOLS/Modules"),
    QueryEditor,
    TabellaCustomAdapter,
  },
  props: {
    admin: Boolean,
  },
  data() {
    return {
      query_analizzata: false,
      query_controllo_analizzata: false,
      lsPrefix: "",
      dbAttuale: null,
      alert: {
        delete: new Object(),
        edit: new Object(),
        query: new Object(),
        query_controllo: new Object(),
      },
      customers: [],
      dialog_query_table: false,
      editor: [
        {
          targetProperty: "",
          color: "red",
          keyword: "@",
          targetField: null,
          template: {},
        },
      ],
      filter: null,
      from_label: true,
      items_famiglie_report: new Array(),
      menu_test: {
        customer: new Object(),
        parameters: null,
        report: null,
        show: false,
      },
      NETWORK: null,
      ui: {
        param_headers: [
          { text: "Parametro", value: "parametro" },
          { text: "Valore", value: "valore" },
          { text: null, value: "_delete" },
        ],
      },
      lista_query: [],
      headers_parametri: [
        { text: "Label", value: "label" },
        { text: "Valore", value: "value" },
      ],
      query_sel: {},
      overlay: false,
      dialog_parametri: false,
      dialog_parametri_controllo: false,
      parametri_sel: [],
      dialog_preview: false,
      preview: {},
    };
  },
  mounted() {
    this.NETWORK = this.$store.state.Network;
    this.getReportAziende();
    this.getListaQuery();
    this.getTabelle();
  },
  destroyed() {
    /*window.freeComponent(this);*/
  },
  methods: {
    async generateDictionary(report, parameters) {
      this.overlay = true;
      for (const p of parameters) {
        localStorage.setItem(this.lsPrefix + p.parametro, p.valore);
      }
      if (report == null || parameters == null) {
        return;
      }
      report = window.cloneDeep(report);
      try {
        const query = report.query;
        for (let i = 0; i < query.length; i++) {
          query[i].query = btoa(encodeURIComponent(query[i].query));
        }
        report.query = btoa(unescape(encodeURIComponent(JSON.stringify(report.query))));
      } catch (error) {
        report.query = btoa(unescape(encodeURIComponent(JSON.stringify([]))));
      }

      let request = {
        controller: "Global",
        method: "POST",
        richiesta: {
          action: "getdictionary",
          report: report,
          parametri: parameters,
          token: localStorage.getItem("user_token"),
        },
      };

      await this.$store.dispatch("api6", request).then((res) => {
        const temp = document.createElement("a");
        const file = new Blob([res.data.result], { type: "text/plain" });
        temp.href = URL.createObjectURL(file);
        temp.setAttribute("download", "dictionary.frd");
        document.body.appendChild(temp);
        temp.click();
        document.body.removeChild(temp);
      });
      this.overlay = false;
    },
    analizzaQuery(arg) {
      this.query_analizzata = arg;
    },
    analizzaQueryControllo(arg) {
      this.query_controllo_analizzata = arg;
    },
    getParams() {
      this.alert.edit.menu_test.parameters = [];
      for (const q of this.alert.edit.report.query) {
        let params = [...q.query.matchAll("@\\w+")];
        for (const p of params) {
          if (
            this.alert.edit.menu_test.parameters.filter((e) => e.parametro == p[0])
              .length == 0
          ) {
            this.alert.edit.menu_test.parameters.push({
              parametro: p[0],
              valore: "",
            });
            if (localStorage.getItem(this.lsPrefix + p[0]) != null) {
              this.alert.edit.menu_test.parameters[
                this.alert.edit.menu_test.parameters.length - 1
              ].valore = localStorage.getItem(this.lsPrefix + p[0]);
            }
          }
        }
      }
    },
    async getReportAziendaNew(db, id) {
      this.overlay = true;
      let request = {
        controller: "Report",
        method: "POST",
        richiesta: {
          action: "getreportaziendanew",
          token: localStorage.getItem("user_token"),
          db: db,
          id_report: id,
        },
      };
      var result;
      await this.$store.dispatch("api", request).then((res) => {
        result = res.data.result;
        for (let j = 0; j < result.length; j++) {
          var report = result[j];
          report.id = `${report.id_azienda}.${report.id_report}`;
          try {
            report.query = JSON.parse(decodeURIComponent(escape(atob(report.query))));

            for (let z = 0; z < report.query.length; z++) {
              try {
                report.query[z].query = decodeURIComponent(atob(report.query[z].query));
              } catch (error) {
                report.query[z].query = null;
              }
            }
          } catch (error) {
            console.log("errore decodifca query", error);
            report.query = [{ query: report.query }];
          }

          try {
            report.query_controllo = decodeURIComponent(
              escape(atob(report.query_controllo))
            );
          } catch (error) {
            report.query_controllo = null;
          }
        }
      });
      this.overlay = false;
      return result[0];
    },
    addParam(parameters) {
      parameters.push({ parametro: null, valore: null });
    },
    apriDialogQueryToTable() {
      this.dialog_query_table = true;
    },
    changeQuery(arg) {
      this.alert.edit.report.query[0].query = arg.query1[0].query;
    },
    closeDialogQueryToTable() {
      this.getListaQuery();
      this.dialog_query_table = false;
    },
    removeParam(param, parameters) {
      const index = parameters.indexOf(param);
      if (index >= 0) {
        parameters.splice(index, 1);
      }
    },
    filterCustomers(filter) {
      if (filter == null || filter == "") {
        return this.customers;
      }
      const result = new Array();
      filter = filter.toLowerCase();
      for (let i = 0; i < this.customers.length; i++) {
        const customer = this.customers[i];
        if (customer.ragione_sociale.toLowerCase().indexOf(filter) >= 0) {
          result.push(customer);
        }
      }
      return result;
    },
    deleteReport() {
      const report = window.cloneDeep(this.alert.delete.report);
      report.validita = 0;
      this.setReportAzienda(report);
    },
    async downloadReportModel(src_report = null) {
      const report = await this.getReportAziendaNew(src_report.db, src_report.id_report);
      let model = null;
      try {
        model = decodeURIComponent(atob(report.modello));
      } catch (err) {
        model = report.modello;
      }
      const _blob = new Blob([model], { type: "text/plain" });
      const url = window.URL.createObjectURL(_blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${src_report.customer_name} - ${report.cod_report}.frx`;
      a.click();
    },
    uploadReportModel() {
      const that = this;
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", ".frx");
      input.onchange = function () {
        const reader = new FileReader();
        reader.onload = function () {
          const parser = new DOMParser();
          const project = parser.parseFromString(reader.result, "text/xml");
          const tables = project.getElementsByTagName("TableDataSource");
          const report = that.alert.edit.report;
          if (tables.length > 0) {
            const tables_result = new Array();
            for (let i = 0; i < tables.length; i++) {
              const table = tables[i].getAttribute("Name");
              let found = false;
              for (let j = 0; j < report.query.length; j++) {
                if (report.query[j].nome_tabella == table) {
                  found = true;
                  tables_result.push(report.query[j]);
                  break;
                }
              }
              if (!found) {
                tables_result.push({
                  nome_tabella: table,
                  query: null,
                });
              }
            }
            report.query = tables_result;
          } else {
            report.query = [{ query: "", nome_tabella: "" }];
          }
          report.modello = btoa(encodeURIComponent(reader.result));
        };
        reader.readAsText(input.files[0]);
      };
      input.click();
    },
    getReportAziende() {
      const that = this;
      const request = {
        controller: "Report",
        response: { parse: false },
        body: {
          action: "getreportaziende",
          token: localStorage.user_token,
        },
        method: "POST",
        on: {
          load: function (response) {
            response = JSON.parse(response).azienda;
            for (let i = 0; i < response.length; i++) {
              const customer = response[i];
              customer.id = customer.id_azienda.toString();
              for (let j = 0; j < customer.report.length; j++) {
                const report = customer.report[j];
                report.id = `${report.id_azienda}.${report.id_report}`;
                report.customer_name = customer.ragione_sociale;
                report.db = customer.nome_database;
                try {
                  report.query = JSON.parse(
                    decodeURIComponent(escape(atob(report.query)))
                  );
                  for (let z = 0; z < report.query.length; z++) {
                    try {
                      report.query[z].query = decodeURIComponent(
                        atob(report.query[z].query)
                      );
                    } catch (error) {
                      report.query[z].query = null;
                    }
                  }
                } catch (error) {
                  /* Se si arriva qui è perché probabilmente la query
                   * non è un base 64 e non si è riusciti a decodificarla
                   * quindi, non essendo un base 64 ma una query scritta
                   * direttamente in SQL, la inserisco nel parametro di
                   * destinazione così com'è. */
                  report.query = [{ query: report.query }];
                }
              }
            }
            that.customers = response;
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
    getTabelle() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "FAMIGLIA_REPORT",
          filter: `validita = 1`,
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.items_famiglie_report = res.data;
      });
    },
    openDialogParametri() {
      if (this.alert.query.query.null.length != 0) {
        this.alert.query.query.null.forEach((e) => {
          let obj = {};
          for (const key in e) {
            obj.label = e[key];
          }
          obj.value = "";
          this.parametri_sel.push(obj);
        });
      }
      this.dialog_parametri = true;
    },
    openDialogParametriControllo() {
      if (this.alert.query_controllo.query.null.length != 0) {
        this.alert.query_controllo.query.null.forEach((e) => {
          let obj = {};
          for (const key in e) {
            obj.label = e[key];
          }
          obj.value = "";
          this.parametri_sel.push(obj);
        });
      }
      this.dialog_parametri_controllo = true;
    },
    getListaQuery() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getquerydettaglio",
          token: localStorage.user_token,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.data.result.query.length != 0) {
          this.lista_query = res.data.result.query;
        }
      });
    },
    setReportAzienda(report) {
      report = window.cloneDeep(report);
      this.alert.edit.show = false;
      try {
        const query = report.query;
        for (let i = 0; i < query.length; i++) {
          query[i].query = btoa(encodeURIComponent(query[i].query));
        }
        report.query = btoa(unescape(encodeURIComponent(JSON.stringify(report.query))));
      } catch (error) {
        report.query = btoa(unescape(encodeURIComponent(JSON.stringify([]))));
      }

      if (report.query_controllo != null) {
        try {
          report.query_controllo = btoa(
            unescape(encodeURIComponent(report.query_controllo))
          );
        } catch (error) {
          report.query_controllo = null;
        }
      }

      const that = this;
      const request = {
        controller: "Report",
        response: { parse: false },
        body: {
          action: "setreportazienda",
          token: localStorage.user_token,
          id_azienda: report.id_azienda,
          report: [report],
        },
        method: "PUT",
        on: {
          load: function () {
            that.getReportAziende();
            that.alert.delete.show = false;
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },

    salvaDictionary(val) {
      let query_sel = this.alert[val].query.query;

      this.overlay = true;
      let query_str = "";
      if (this.parametri_sel.length != 0) {
        this.parametri_sel.forEach((p) => {
          query_str =
            query_str != ""
              ? query_str.replaceAll(p.label, p.value)
              : query_sel.replaceAll(p.label, p.value);
        });
      } else {
        query_str = query_sel;
      }

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "performquery",
          token: localStorage.user_token,
          query_string: query_str,
          database: this.dbAttuale,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.result.length != 0) {
              console.log(res.data.result.Table);
              var frd =
                '<?xml version="1.0" encoding="utf-8"?>\n' +
                "<Dictionary>\n" +
                '<TableDataSource Name="TABELLA" ReferenceName="DataSet.TABELLA"' +
                ' DataType="System.Int32" Enabled="true">\n';
              Object.keys(res.data.result.Table[0]).forEach((e) => {
                frd += '<Column Name="' + e + '" DataType=';
                if (/^\d+$/.test(res.data.result.Table[0][e]))
                  frd += '"System.Int32"/>\n';
                else frd += '"System.String"/>\n';
              });
              frd += "</TableDataSource>\n</Dictionary>";

              const temp = document.createElement("a");
              const file = new Blob([frd], { type: "text/plain" });
              temp.href = URL.createObjectURL(file);
              temp.setAttribute("download", "dictionary.frd");
              document.body.appendChild(temp);
              temp.click();
              document.body.removeChild(temp);
            } else {
              this.$refs.SnackbarQV.print(
                "error",
                "Nessun risultato disponibile per questa query."
              );
              this.overlay = false;
            }
          } else {
            this.$refs.SnackbarQV.print("error", "Query non valida.");
            this.overlay = false;
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },

    playQuery(val) {
      let query_sel = this.alert[val].query.query;

      this.overlay = true;
      let query_str = "";
      if (this.parametri_sel.length != 0) {
        this.parametri_sel.forEach((p) => {
          query_str =
            query_str != ""
              ? query_str.replaceAll(p.label, p.value)
              : query_sel.replaceAll(p.label, p.value);
        });
      } else {
        query_str = query_sel;
      }

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "performquery",
          token: localStorage.user_token,
          query_string: query_str,
          database: this.dbAttuale,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            if (res.data.result.length != 0) {
              this.preview = {};
              for (const [e, value] of Object.entries(res.data.result)) {
                let obj_tmp = {
                  colonne: [],
                  name: e,
                  result: value,
                };

                let headers = [];
                for (let field in value[0]) {
                  headers.push({
                    text: field.includes("#")
                      ? field.split("#")[1].replaceAll("_", " ")
                      : field.replaceAll("_", " "),
                    value: field,
                    sortable: false,
                  });
                }

                obj_tmp.colonne = headers;
                this.preview = obj_tmp;
                this.dialog_preview = true;
              }
            } else {
              this.$refs.SnackbarQV.print(
                "error",
                "Nessun risultato disponibile per questa query."
              );
              this.overlay = false;
            }
          } else {
            this.$refs.SnackbarQV.print("error", "Query non valida.");
            this.overlay = false;
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    showDeleteDialog(report) {
      this.alert.delete = {
        customer_name: report.customer_name,
        report_name: report.cod_report,
        report: report,
        show: true,
      };
    },
    async showEditDialog(report, customer = null) {
      if (report != null) {
        this.lsPrefix =
          report.id_azienda.toString() + "." + report.id_report.toString() + ".";
      }
      var tempReport;
      if (report != null) {
        tempReport = await this.getReportAziendaNew(report.db, report.id_report);
      }
      if (report != null) {
        this.dbAttuale = this.customers.filter(
          (e) => e.ragione_sociale == report.customer_name
        )[0]?.nome_database;
      } else if (customer != null) {
        this.dbAttuale = customer.nome_database;
      }

      let text = null;
      if (customer != null) {
        tempReport = {
          id_report: -1,
          id_azienda: customer.id_azienda,
          modello: null,
          query: new Array(),
          query_controllo: null,
          validita: 1,
          cod_report: null,
        };
        text = `Crea nuovo report per ${customer.ragione_sociale}`;
      } else {
        text = `Modifica "${report.cod_report}" per ${report.customer_name}`;
        if (tempReport.query[0] && tempReport.query[0].query != null) {
          this.lista_query.forEach((e) => {
            if (e.query1[0].query == tempReport.query[0].query) {
              this.query_sel = e;
            }
          });
        }
      }

      if (report != null) {
        tempReport.db = report.db;
        tempReport.customer_name = report.customer_name;
      }

      this.alert.edit = {
        menu_test: {
          parameters: new Array(),
          show: false,
        },
        show: true,
        report: window.cloneDeep(tempReport),
        text: text,
      };
    },
    saveQuery() {
      const query_alert = this.alert.query;
      const target = this.alert.edit.report.query[query_alert.index];
      delete query_alert.query.null;
      target.query = query_alert.query.query;
      this.alert.query = new Object();
    },
    saveQueryControllo() {
      const query_alert = this.alert.query_controllo;
      const target = this.alert.edit.report;
      delete query_alert.query.null;
      target.query_controllo = query_alert.query.query;
      this.alert.query_controllo = new Object();
    },
    showQueryDialog(query, index) {
      this.alert.query = {
        show: true,
        query: query,
        index: index,
      };
    },
    showQueryControlloDialog(query) {
      this.alert.query_controllo = {
        show: true,
        query: { tabella: "t_report", query: query },
      };
    },
    testReport(report, parameters) {
      for (const p of parameters) {
        localStorage.setItem(this.lsPrefix + p.parametro, p.valore);
      }
      if (report == null || parameters == null) {
        return;
      }
      report = window.cloneDeep(report);
      try {
        const query = report.query;
        for (let i = 0; i < query.length; i++) {
          query[i].query = btoa(encodeURIComponent(query[i].query));
        }
        report.query = btoa(unescape(encodeURIComponent(JSON.stringify(report.query))));
      } catch (error) {
        report.query = btoa(unescape(encodeURIComponent(JSON.stringify([]))));
      }

      const request = {
        controller: "Report",
        response: { parse: false },
        body: {
          action: "testreportpdf",
          token: localStorage.user_token,
          report: report,
          parametri: parameters,
        },
        method: "POST",
        on: {
          load: function (response) {
            const byteCharacters = atob(JSON.parse(response).result);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], {
              type: "application/pdf",
            });
            const blobUrl = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = `test.pdf`;
            a.click();
          },
        },
      };
      this.NETWORK.AjaxRequest(request);
    },
  },
};
</script>
<style scoped>
.report_manager {
  padding: 20px;
}
.report_manager .tree_container {
  display: block;
  margin: 0 auto;
  max-width: 600px;
  width: 100%;
}
.report_manager .tree_label {
  font-size: 14px;
  width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: block;
}
.report_manager .tree_label[data-customer] {
  font-weight: bold;
  overflow: visible;
}
</style>
